import React from 'react';
//import business from '../../style/images/e-business.png';

const Header = () => {
    return (
        <footer>
            <div className='support'>
                {/*<span className='support-number'> :شماره تماس پشتیبانی</span>*/}
                {/*<span className='number'>021 - 91072737</span>*/}
            </div>
            <div className='copyright'>
              <span>.تمامی حقوق برای کیپا محفوظ می‌باشد</span>
            </div>
        </footer>
    )
};
export default Header;